module.exports = __webpack_public_path__ + "static/www/img/CTD.e438bea.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/conference/CTD.jpg
// module id = 375
// module chunks = 1